"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

declare global {
  interface Window {
    __cmsEditorExternalScripts?: Set<string>;
  }
}

export default function ScriptRunnerEditor({
  inlineScripts = [],
  externalScripts = [],
}: {
  inlineScripts?: string[];
  externalScripts?: string[];
}) {
  const pathname = usePathname();

  useEffect(() => {
    // Run inline scripts immediately
    inlineScripts.forEach((code, i) => {
      try {
        new Function(code)();
      } catch (err) {
        console.error("⚠️ Inline script error:", err);
      }
    });

    // Inject external scripts manually
    externalScripts.forEach((src, i) => {
      const runnerId = `editor-external-${pathname}-${i}`;

      // Remove duplicates for this path
      const old = document.querySelector(`script[data-editor-runner="${runnerId}"]`);
      if (old) old.remove();

      const s = document.createElement("script");
      s.src = src;
      s.async = true;
      s.dataset.editorRunner = runnerId;

      document.body.appendChild(s);
    });

    // console.log(`✅ Editor scripts executed for path: ${pathname}`);
  }, [pathname]);

  return null;
}